<template>
	<div>
		<page-loading :loading="page.loading"></page-loading>
		<div v-if="!page.loading" class="max-w-400 mx-auto py-4">
			<error-list :errors="page.errors"></error-list>

			<div v-if="account.confirmed">
				<div>
					Thank you for confirming your email address!
					An administrator will review your account and you will receive an email when it is approved.
				</div>
			</div>
			<div v-else-if="!resent">
				<b-button type="button" variant="primary" @click="resendEmail">Re-send Confirmation Email</b-button>
			</div>
			<div v-else>
				<div>
					A new email has been sent to your email address with a link to confirm your account.
					Please be sure to click the link within <b>24 hours</b>.
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'AccountConfirm',
		data() {
			return {
				page: {
					errors: [],
					loading: true
				},
				account: {
					confirmed: false
				},
				resent: false
			}
		},
		async created() {
			await this.confirmAccount();
		},
		methods: {
			confirmAccount: async function () {
				this.page.errors = [];
				this.page.loading = true;

				try {
					const response = await this.$http.get('account/confirm?userId=' + encodeURIComponent(this.$route.params.userId) + '&code=' + encodeURIComponent(this.$route.params.code));
					this.account.confirmed = true;
					this.logout(false);
				} catch (error) {
					this.page.errors = this.logError(error);
				}

				this.page.loading = false;
			},
			resendEmail: async function () {
				this.page.errors = [];
				this.page.loading = true;

				try {
					const response = await this.$http.post('account/resenduserconfirmation/' + encodeURIComponent(this.$route.params.userId), {});
					this.resent = true;
					this.logout(false);
				} catch (error) {
					this.page.errors = this.logError(error);
				}

				this.page.loading = false;
			}
		}
	}
</script>
